import "./Comment.less";
import IntlMessages from "../../../util/IntlMessages";
interface CommentProps {
   author: string;
   content: React.ReactElement;
   avatar: React.ReactElement;
   datetime: string;
   className?: string;
   recipient?: string;
}

export const Comment: React.FC<CommentProps> = ({
   author,
   avatar,
   content,
   className = "",
   datetime,
   recipient,
}) => {
   return (
      <div className={`${className} bp2-comment`} data-testid="bp2-comment">
         <div className="bp2-comment__inner">
            <div className="bp2-comment__inner__avatar">{avatar}</div>
            <div className="bp2-comment__inner__content">
               <div className="bp2-comment__inner__content__author">
                  <p className="p2 bp2-comment__inner__content__author__name">
                     {author}{" "}
                     {recipient && (
                        <span>
                           <IntlMessages id="email.writeMailRecipient" />:{" "}
                        </span>
                     )}{" "}
                     {recipient && recipient}
                  </p>
                  <p className="p3 bp2-comment__inner__content__author__time">{datetime}</p>
               </div>
               {content}
            </div>
         </div>
      </div>
   );
};
